jQuery(document).ready(function ($) {

    $('.home_news__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        speed: 300,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        centerMode: true,
        cssEase: 'linear',
        asNavFor: '.home_news__items_nav'
    });

    $('.home_news__items_nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.home_news__items',
        centerMode: true,
        focusOnSelect: true,
        centerPadding: '60px',
        speed: 300,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        cssEase: 'linear',
        arrows: true,
        dots: true,
        responsive: [
            {
                breakpoint: 998,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

});